module.exports = __webpack_public_path__ + "img/icon3.2a2e0a4b.png";